"use client";

import React, { ReactNode } from "react";

import { cn } from "@perceptron/utils/cn";

import { useDropZone } from "@demo/hooks/useDropZone";

interface EditorDropZoneProps {
  children: ReactNode;
  className?: string;
  "data-testid"?: string;
  "data-drop-zone"?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onFilesDropped?: (files: File[]) => void;
  style?: React.CSSProperties;
}

export const EditorDropZone = React.memo(
  ({
    children,
    className,
    "data-testid": dataTestId,
    "data-drop-zone": dataDropZone,
    onClick,
    onFilesDropped,
    style,
  }: EditorDropZoneProps) => {
    const { isDragOver, isDragOverMediaSet, handlers } = useDropZone({
      onFilesDropped,
      detectMediaSet: true,
    });

    return (
      <div
        className={cn(className, isDragOver && !isDragOverMediaSet && "border-[2px] border-primary")}
        data-drop-zone={dataDropZone}
        data-testid={dataTestId}
        style={style}
        onClick={onClick}
        {...handlers}
      >
        {children}
      </div>
    );
  },
);

EditorDropZone.displayName = "EditorDropZone";
